import React, { useContext, useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import styled from 'styled-components';
import { getYAPlan } from '../common/commonSlice';
import { useDispatch } from 'react-redux';
import Modal from '../../components/common/Modal';
import Typography from '../../components/common/Typography';
import AlertContext from '../../context/AlertContext';
import { getCurrentYear } from '../../common/Util';

/*
    연말 정산 일정 캘린더
*/

const ScheduleScreen = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const {
    alertActions: { alertMessage },
  } = useContext(AlertContext);
  const [planList, setPlanList] = useState(null); // 일정 리스트
  const [calendarList, setCalendarList] = useState({}); // 달력 표시

  useEffect(() => {
    const fetchYAPlan = async () => {
      try {
        const yaPlan = await dispatch(getYAPlan()).unwrap();

        console.log('yaPlan >>', yaPlan);

        if (yaPlan.resultCode === '1') {
          const data = yaPlan;

          const formatDate = dateStr => {
            const month = parseInt(dateStr.substring(4, 6), 10);
            const day = parseInt(dateStr.substring(6, 8), 10);
            return `${month}월 ${day}일`;
          };

          const {
            htmD1SD,
            htmD1ED,
            htmC1SD,
            htmC1ED,
            htmS1SD,
            htmS1ED,
            htmC2SD,
            htmC2ED,
            htmS2SD,
            htmS2ED,
          } = data;

          setPlanList(
            <PlanListContainer>
              <PlanItem color="#ff0000">
                <Typography className="captionMedium">
                  {formatDate(htmD1SD)} ~ {formatDate(htmD1ED)} : 1차 서류 작성
                </Typography>
              </PlanItem>
              <PlanItem color="#ff7f00">
                <Typography className="captionMedium">
                  {formatDate(htmC1SD)} ~ {formatDate(htmC1ED)} : 1차 서류 검토
                </Typography>
              </PlanItem>
              <PlanItem color="#ffff00">
                <Typography className="captionMedium">
                  {formatDate(htmS1SD)} ~ {formatDate(htmS1ED)} : 1차 결과 OPEN
                </Typography>
              </PlanItem>
              {(htmC2SD || htmC2ED) && (
                <PlanItem color="#008080">
                  <Typography className="captionMedium">
                    {formatDate(htmC2SD)} ~ {formatDate(htmC2ED)} : 추가 서류 검토
                  </Typography>
                </PlanItem>
              )}
              <PlanItem color="#0000ff">
                <Typography className="captionMedium">
                  {formatDate(htmS2SD)} ~ {formatDate(htmS2ED)} : 최종결과 OPEN
                </Typography>
              </PlanItem>
            </PlanListContainer>,
          );

          const addPeriod = (start, end, color, target, index) => {
            for (let i = parseInt(start, 10); i <= parseInt(end, 10); i++) {
              const dateStr = i.toString();
              if (dateStr.length !== 8) continue;
              const formattedDate = `${dateStr.substring(0, 4)}-${dateStr.substring(
                4,
                6,
              )}-${dateStr.substring(6, 8)}`;

              if (!target[formattedDate]) {
                target[formattedDate] = { periods: [] };
              }

              const period = {
                startingDay: i === parseInt(start, 10),
                endingDay: i === parseInt(end, 10),
                color: color,
                index: index,
              };

              target[formattedDate].periods.push(period);
            }
          };

          const periods = {};

          // 1차 서류 작성
          addPeriod(htmD1SD, htmD1ED, '#ff0000', periods, 0);
          // 1차 서류 검토
          addPeriod(htmC1SD, htmC1ED, '#ff7f00', periods, 1);
          // 1차 결과 OPEN
          addPeriod(htmS1SD, htmS1ED, '#ffff00', periods, 2);
          // 추가 서류 검토
          if (htmC2SD && htmC2ED) {
            addPeriod(htmC2SD, htmC2ED, '#008080', periods, 3);
          }
          // 최종결과 OPEN
          addPeriod(htmS2SD, htmS2ED, '#0000ff', periods, 4);

          setCalendarList(periods);
        } else {
          alertMessage('일정을 불러올 수 없습니다.');
        }
      } catch (error) {
        console.error('에러 발생:', error);
      }
    };

    fetchYAPlan();
  }, [dispatch]);

  return (
    <Modal
      onClose={onClose}
      height="auto"
      width="calc(100% - 20px)"
      innerStyle={{ padding: '20px' }}
      onClickBackground={onClose}>
      <ModalContent>
        <Title>{getCurrentYear()}년 연말정산 일정</Title>
        <StyledCalendar
          value={new Date()}
          onChange={() => {}}
          tileClassName={({ date }) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const dateStr = `${year}-${month}-${day}`;

            if (calendarList[dateStr]) {
              return `period-${calendarList[dateStr].periods[0].index}`;
            }
            return '';
          }}
        />
        <DividerStyled />
        {planList}
      </ModalContent>
    </Modal>
  );
};

const PlanListContainer = styled.div`
  margin-left: 10px;
  width: 100%;
  display: flex;
  gap: 4px;
  flex-direction: column;
`;

const PlanItem = styled.div`
  display: flex;
  align-items: center;
  // margin-bottom: 12px;
  position: relative;
  padding-left: 20px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    background-color: ${props => props.color};
    border-radius: 2px;
  }
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h2`
  margin-bottom: 20px;
`;

const StyledCalendar = styled(Calendar)`
  width: 100%;
  max-width: 320px;
  background: white;
  border: 1px solid #ddd;

  * {
    font-size: 12px;
  }

  .react-calendar__tile {
    position: relative;
    font-size: 12px;
  }

  .react-calendar__tile {
    * {
      font-size: 12px;
    }
  }

  .react-calendar__tile:hover {
    background: #f0f0f0;
  }

  .react-calendar__navigation {
    margin-bottom: 0px;
  }

  /* 각 기간별 스타일 */
  .period-0 {
    background-color: rgba(255, 0, 0, 0.2) !important; /* 1차 서류 작성 */
  }

  .period-1 {
    background-color: rgba(255, 127, 0, 0.2) !important; /* 1차 서류 검토 */
  }

  .period-2 {
    background-color: rgba(255, 255, 0, 0.2) !important; /* 1차 결과 OPEN */
  }

  .period-3 {
    background-color: rgba(0, 128, 128, 0.2) !important; /* 추가 서류 검토 */
  }

  .period-4 {
    background-color: rgba(0, 0, 255, 0.2) !important; /* 최종결과 OPEN */
  }

  .react-calendar__tile {
    position: relative;
    // height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
  }

  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: inherit;
    opacity: 0.8;
  }

  /* 요일 밑의 도트 제거 */
  .react-calendar__month-view__weekdays__weekday abbr {
    text-decoration: none;
    text-underline-offset: 0;
  }

  /* 또는 아래 스타일도 사용 가능 */
  .react-calendar__month-view__weekdays__weekday {
    abbr[title] {
      text-decoration: none;
    }
  }
`;

const DividerStyled = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid #ddd;
  margin: 10px 0;
`;

export default ScheduleScreen;
